import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { ModuleVOConfigScope } from '../moduleVoNavigation'

export interface ModuleVOEditParams {
    brand: string | null
    dealershipIds: number[]
    scope: ModuleVOConfigScope
}

export function useModuleVOEditParams(): ModuleVOEditParams {
    const location = useLocation()

    return useMemo(() => {
        const searchParams = new URLSearchParams(location.search)

        const brand = searchParams.get('brand')
        const dealershipIdsParam = searchParams.get('dealershipIds') ?? searchParams.get('dealershipId')
        const dealershipIds = dealershipIdsParam
            ? dealershipIdsParam.split(',').map(Number).filter(id => !Number.isNaN(id))
            : []

        const scope: ModuleVOConfigScope = brand ? 'brand' : dealershipIds.length > 0 ? 'site' : 'global'

        return { brand, dealershipIds, scope }
    }, [ location.search ])
}
